export const SPECIES_LIST_PATH = "/admin/settings/species";
export const RESEARCH_TYPE_LIST_PATH = "/admin/settings/researchType";
export const RESEARCH_TYPE_PATH = "/admin/settings/researchType/:researchTypeId/";
